import Vue from 'vue'
import Vuex from 'vuex'
import decode from 'jwt-decode'
import router from '../router/index'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    usuario: null,

    listaDeudoresStore: [],
    deudorStore: {},

    listaVisitasStore: [],
    visitaStore: {},

    listaUsuariosStore: [],
    usuarioStore: {}
  },
  mutations: {
    setToken(state, token) {
      state.token = token
    },

    setUsuario(state, usuario) {
      state.usuario = usuario
    },
  },
  actions: {
    guardarToken({ commit }, token) {
      commit("setToken", token)
      commit("setUsuario", decode(token))
      localStorage.setItem("token-notificador", token)
      router.push({ name: 'Home' })

    },

    autoLogin({ commit }) {
      let token = localStorage.getItem("token-notificador")
      if (token) {
        commit("setToken", token)
        commit("setUsuario", decode(token))
        router.push({ name: 'Home' })

      }
    },

    salir({ commit }) {
      commit("setToken", null)
      commit("setUsuario", null)
      localStorage.removeItem("token-notificador")
      router.push({ name: 'Login' })
    },
  },
  modules: {
  }
})
